




















































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
import MallConfig from '@/api/mall/mallConfig/index'
import SelectUrl from '@/components/selectUrl/index.vue'
@Component({
  components: {
    PicModal,
    SelectUrl
  }
})
export default class AdvertSetting extends Vue {
  AdvertConfig = {
    isActive: true,
    showType: 0,
    imgs: [
      {
        img: null,
        url: null
      }
    ]
  }
  MallUrlList = []

  mounted() {
    this.getConfig()
  }

  /**
   * 获取设置
   */
  getConfig() {
    MallConfig.getMallConfig('AdvertConfig').then(res => {
      if (res.data) {
        this.AdvertConfig = res.data
      }
    })
  }

  /**
   * 选择图片
   */
  picChange(e, index) {
    this.AdvertConfig.imgs[index]['img'] = e[0].url
  }

  urlChange(e, index) {
    this.AdvertConfig.imgs[index]['url'] = e
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.AdvertConfig.imgs.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      img: null,
      url: null
    }
    this.AdvertConfig.imgs.push(obj)
  }

  submitFn() {
    let vm = this
    let AdvertConfig: any = vm.$refs.AdvertConfig
    AdvertConfig.validate(valid => {
      if (valid) {
        MallConfig.updateMallConfig(
          'AdvertConfig',
          '弹窗广告设置',
          vm.AdvertConfig
        ).then(res => {
          vm.$Notice.success({
            desc: '提交成功'
          })
          vm.getConfig()
        })
      }
    })
  }
}
